export default __webpack_public_path__ + "static/media/a15.4a2f5694.jpg";